import React, { useState } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom'; // Add this import
import AgreementApiService from '../../ApiServices/SettingApiServices/AgreementApiService';

// Set custom styles for the modal
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    borderRadius: '8px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
    backgroundColor: '#f9f9f9',
    width: '500px',
  },
};

const AgreementForm = () => {

  const [formData, setFormData] = useState({

    FirstName: '',
    LastName: '',
    Company: '',
    PhoneNumber: ''
  });
  const handleDownloadAgreement = () => {
    alert('Downloading agreement...');
  };
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

  const handleDownload = async () => {
      try {
          const response = await fetch(`${baseUrl}Agreement/Get`, {
              method: "GET",
          });
  
          if (!response.ok) {
              alert("Failed to download agreement.");
              return;
          }
  
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
  
          const link = document.createElement("a");
          link.href = url;
          link.download = "Agreement.pdf";  // Rename file as needed
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      } catch (error) {
          console.error("Download error:", error);
          alert("An error occurred while downloading.");
      }
  };
  
  // const fetchData = async () => {
  //     try {
  //         var UserId = "19d649d9-41e6-4e2b-bf80-ddcbf43b876c";
  //         const settingData = await AccountDetailApiService.Get(UserId);

  //         console.log("Combined Data:", settingData.data); // Check the structure here
  //         setFormData(settingData.data);
  //     } catch (error) {
  //         console.error("Error fetching data:", error);
  //     }
  // };

  // fetchData();

  const [loading, setLoading] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };



  //     const handleSubmit = async (e) => {
  //       e.preventDefault();
  //       setLoading(true);



  //       const accountDetailData = {

  //         FirstName: document.getElementById('FirstName').value,
  //         LastName: document.getElementById('LastName').value,
  //         Company: document.getElementById('Company').value,
  //         PhoneNumber: document.getElementById('PhoneNumber').value,
  //         // AppWeb: document.getElementById('AppWeb').value,
  //         Id: "19d649d9-41e6-4e2b-bf80-ddcbf43b876c",
  //       };

  //       try {
  //            const result = await AccountDetailApiService.Update(accountDetailData); // Call API service
  //             toast.success(result.message);

  //         //   closeModal(); 
  //       } catch (error) {
  //           toast(error.message);
  //           console.error('Update User Detail error:', error);
  //       } finally {
  //           setLoading(false);
  //       }
  //   };
  return (
    <>
      <ToastContainer />


      <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-aos="fade-up">
        <h2 className="text-xl font-semibold mb-4">Agreement Detail</h2>
        <p className="mb-4 text-gray-600">
          Proposed by Adspace-tech.
          <br /> For more info, please Add a <strong>QA Ticket</strong> Our team will contact you ASAP
        </p>
        <button onClick={handleDownload}
          className="flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2">
          Download Agreement
        </button>
      </div>

    </>
  );
};

export default AgreementForm;
